<template>
    <TransitionRoot as="template" :show="showPopUp">
        <Dialog as="div" class="fixed z-20 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 text-center">
                            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                                <font-awesome-icon :icon="faExclamation" class="h-6 w-6 text-red-500" aria-hidden="true" />
                            </div>
                            <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900 text-left mt-4">
                                Prospective tenants that do not have a Social Security Number will not be able to obtain a credit report or criminal background report, and will not be able to proceed with this application process.
                            </DialogTitle>
                            <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900 text-left mt-4">
                                Los posibles inquilinos que no tengan un número de seguro social no podrán obtener un informe de crédito o un informe de antecedentes penales, y no podrán continuar con este proceso de solicitud.
                            </DialogTitle>

                            <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900 text-left mt-4">
                                Please contact support if you have questions.
                            </DialogTitle>
                        </div>
                        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-2">
                            <button type="button" class="primaryButton" @click="handleClose()" ref="cancelButtonRef">I Acknowledge</button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script setup>import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faExclamation } from '@fortawesome/pro-light-svg-icons'

import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from "@headlessui/vue";
import {ref, watch} from "vue";

const props = defineProps({
    show: Boolean,
});

const showPopUp = ref(props.show);
const wasManuallyClosed = ref(false);

// Watch for changes to props.show and update showPopUp
// Only update if it wasn't manually closed, or if show becomes false (meaning it should be closed)
watch(() => props.show, (newValue) => {
    // If show becomes false, always respect it (acknowledgment was successful)
    if (!newValue) {
        showPopUp.value = false;
        wasManuallyClosed.value = false;
    } else if (!wasManuallyClosed.value) {
        // Only update if user hasn't manually closed it
        showPopUp.value = newValue;
    }
});

const emit = defineEmits(['closeModal'])

function handleClose() {
    showPopUp.value = false;
    wasManuallyClosed.value = true;
    emit('closeAlert', true)
}

</script>
